import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import objectUtils from '../../_helpers/objectUtils'
import reactQuery from '../../_helpers/reactQuery'
import { homeService } from '../../_services'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const Home = function () {
  const collectionName = 'Homes'
  const singleCollectionName = 'Home'
  const queryKey = collectionName.toLowerCase()
  const singleQueryKey = singleCollectionName.toLowerCase()
  const params = useParams()
  const getQuery = reactQuery.getOneQuery(
    singleQueryKey,
    params.id,
    homeService.get
  )
  const updateMutation = reactQuery.updateMutation(
    homeService.update,
    params.id,
    singleCollectionName,
    singleQueryKey,
    queryKey
  )
  const deleteMutation = reactQuery.deleteMutation(
    homeService.remove,
    params.id,
    singleCollectionName,
    singleQueryKey,
    queryKey
  )
  const [body, setBody] = useState({})
  return (
    <Document
      actions={[
        {
          buttonLabel: `${translate.Update} ${translate[singleCollectionName]}`,
          buttonColor: 'primary',
          onSubmit: (args) => {
            const newBody = objectUtils.compare(getQuery.data, args)
            if (Object.keys(newBody).length)
              return updateMutation.mutate(newBody)
          },
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          form: {
            title: `${translate.Update} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'quote',
                label: 'Quote',
                type: 'text',
                value: getQuery.data?.quote,
              },
              {
                name: 'quoteAR',
                label: 'Arabic Quote',
                type: 'text',
                value: getQuery.data?.quoteAR,
              },
              {
                name: 'quotee',
                label: 'Quotee',
                type: 'text',
                value: getQuery.data?.quotee,
              },
              {
                name: 'quoteeAR',
                label: 'Arabic Quotee',
                type: 'text',
                value: getQuery.data?.quoteeAR,
              },
              {
                name: 'date',
                label: 'Date',
                type: 'date',
                value: getQuery.data?.date,
              },
            ],
          },
        },
        {
          buttonLabel: `${translate.Delete} ${translate[singleCollectionName]}`,
          buttonColor: 'secondary',
          onSubmit: () => deleteMutation.mutate(),
          form: {
            title: `${translate.Delete} ${translate[singleCollectionName]}`,
          },
          confirm: true,
          info: `${translate['Are you sure you want to delete this']} ${translate[singleCollectionName]}`,
        },
      ]}
      title={singleCollectionName}
      getQuery={getQuery}
      many={false}
    />
  )
}
export default Home
